import article from './article';
import coupons from './coupons';
import message from './message';
import presents from './presents';
import products from './products';

export default [message, article, coupons, presents, products];
